import { fontFamily } from 'styles/vars';

/* represents the dimensions for drawing the prep tool label */
export const PREP_TOOL_LABEL = {
  HEIGHT: 19,
  WIDTH_PADDING: 14,
  // represents vertical distance between label and annotation
  GAP: 3,
  FONT_SIZE: 12,
  FONT_WEIGHT: 500,
  FONT_FAMILY: fontFamily,
};

export const PREP_TOOL_ANNOTATION = {
  SELECTED_FILL_STYLE: 'rgba(234, 54, 50, 1)',
  DEFAULT_FILL_STYLE: 'rgba(234, 54, 50, 0.65)',
};

/** PDF page units: color point hitbox in Prep and Color difference annotations (must match). */
export const COLOR_POINT_ANNOTATION_SIZE = 15;
